import IContactNotification from "@myinnsworth/models/contact/IContactNotification";
import HttpServiceBase from "../httpServiceBase";
import { IUpdateContactProfile } from "./models/IUpdateContactProfile";
import { ISearchResults } from "@myinnsworth/models/ISearchResults";
import ISearchContactNotificationsRequestModel from "./models/ISearchContactNotificationsRequestModel";

class ContactHttpService extends HttpServiceBase {
    protected get serviceName(): string { return 'contact' };
    
    public async updateProfile(model: IUpdateContactProfile): Promise<any> {
        return await this.post(`me`, model);
    }

    public async searchNotifications(model: ISearchContactNotificationsRequestModel): Promise<ISearchResults<IContactNotification>> {
        return await this.typedGet<ISearchResults<IContactNotification>>(this.buildSearchUrl(`notifications/search`, model));
    }

    public async setNotificationAsRead(notificationId: number): Promise<any> {
        return await this.put(`notifications/read/${notificationId}`);
    }
}

const service = new ContactHttpService();
export default service;